module.exports = __webpack_public_path__ + "static/media/shingan_doc_protect.9c8850d4.png";